/* libs/shared/src/lib/ui/translations-modal/translations-modal.component.scss */
:host {
  --tm-border: var(--card-border, #e3e8ef);
  --tm-muted: var(--muted, #6b7585);
  --tm-ink: var(--ink, #1f2733);
  --tm-amber: #f59e0b;
  --tm-amber-bg: #fff8ec;
  display: block;
}
.tr-trigger {
  align-items: flex-start;
  background: var(--card-bg, #fff);
  border: 1px solid var(--tm-border);
  border-radius: var(--radius-md, 10px);
  display: flex;
  gap: var(--space-md, 14px);
  padding: var(--space-md, 14px);
}
.tr-trigger-ico {
  align-items: center;
  background: var(--primary-color-light, #eef2f8);
  border-radius: 50%;
  color: var(--primary-color, #61778f);
  display: flex;
  flex: 0 0 auto;
  height: 38px;
  justify-content: center;
  width: 38px;
}
.tr-trigger-text {
  flex: 1 1 auto;
  min-width: 0;
}
.tr-trigger-title {
  color: var(--tm-ink);
  font-size: 14px;
  font-weight: 700;
}
.tr-trigger-sub {
  color: var(--tm-muted);
  font-size: 12.5px;
  margin-top: 2px;
}
.tr-trigger-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.tr-tchip {
  align-items: center;
  background: #f6f9ff;
  border: 1px solid var(--tm-border);
  border-radius: 999px;
  color: var(--tm-muted);
  display: inline-flex;
  font-size: 12px;
  font-weight: 600;
  gap: 6px;
  padding: 4px 10px 4px 7px;
}
.tr-tchip.done {
  background: #effaf3;
  border-color: #b7e7c8;
  color: #1a7f43;
}
.tr-tchip-ck {
  align-items: center;
  color: #1a7f43;
  display: inline-flex;
  font-size: 10px;
}
.tr-tchip-dot {
  background: var(--tm-amber);
  border-radius: 50%;
  display: inline-block;
  height: 7px;
  width: 7px;
}
.tr-trigger-btn {
  align-items: center;
  align-self: center;
  display: inline-flex;
  flex: 0 0 auto;
  gap: 7px;
}
.tr-modal {
  display: flex;
  flex-direction: column;
}
.tg-toolbar {
  align-items: center;
  background: #fafbfc;
  border-bottom: 1px solid var(--tm-border);
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin: -16px -16px 0;
  padding: 14px 18px;
}
.tg-toolbar-note {
  color: var(--tm-muted);
  font-size: 12.5px;
}
.tg-toolbar-spacer {
  flex: 1 1 auto;
}
.btn-ai {
  align-items: center;
  display: inline-flex;
  gap: 7px;
}
.tg-empty {
  align-items: center;
  color: var(--muted-2, #9aa3b0);
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 240px;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
}
.tg-empty .fa-globe {
  font-size: 26px;
}
.tg-wrap {
  margin-top: 14px;
}
.tg-scroll {
  max-height: calc(100vh - 360px);
  min-height: 220px;
  overflow: auto;
}
.tg-grid {
  min-width: 620px;
}
.tg-head,
.tg-row {
  display: grid;
  grid-template-columns: minmax(170px, 0.8fr) minmax(220px, 1fr) minmax(220px, 1fr);
}
.tg-head {
  background: #fafbfc;
  position: sticky;
  top: 0;
  z-index: 1;
}
.tg-h {
  border-bottom: 1px solid var(--tm-border);
  color: var(--section, #8a93a2);
  font-size: 10.5px;
  font-weight: 800;
  letter-spacing: 0.6px;
  padding: 10px 12px;
  text-transform: uppercase;
}
.tg-row {
  border-bottom: 1px solid var(--tm-border);
}
.tg-baserow {
  background: #f7f9fc;
}
.tg-c {
  align-items: center;
  display: flex;
  gap: 8px;
  padding: 9px 12px;
}
.tg-c-lang {
  font-size: 13px;
  font-weight: 600;
}
.tg-lang-name {
  color: var(--tm-ink);
}
.tg-lang-native {
  color: var(--tm-muted);
  font-size: 11.5px;
  font-weight: 500;
}
.tg-base-pill {
  background: #e9edf3;
  border-radius: 4px;
  color: var(--tm-muted);
  font-size: 9.5px;
  font-weight: 800;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  text-transform: uppercase;
}
.tg-c-base {
  color: var(--tm-ink);
  font-size: 13px;
  line-height: 1.4;
}
.tg-base-empty {
  color: var(--muted-2, #9aa3b0);
}
.tg-c-input.missing {
  background: var(--tm-amber-bg);
}
.tg-input {
  border: 1px solid var(--input-border, #d7dce4);
  border-radius: var(--input-radius, 7px);
  font-size: 13px;
  padding: 7px 10px;
  width: 100%;
}
.tg-input:focus {
  border-color: var(--primary-color, #61778f);
  outline: 0;
}
.tr-modal-foot {
  border-top: 1px solid var(--tm-border);
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin: 14px -16px -16px;
  padding: 14px 18px;
}
/*# sourceMappingURL=translations-modal.component.css.map */
